/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useEffect } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export default function Model(props) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('assets/glb-file/49.glb')
  const { actions } = useAnimations(animations, group)

  useEffect(() => {
    //actions['walk'].play();
    //actions['run'].play();
    //actions['photo_shoot'].play();
    //actions['jump'].play();
    actions['idle'].play();
  });

  return (
    <group ref={group} {...props} dispose={null}>
      <group>
        <group name="RootNode0" scale={0.1}>
          <group name="geo1">
            <skinnedMesh name="photographer_character2" geometry={nodes.photographer_character2.geometry} material={nodes.photographer_character2.material} skeleton={nodes.photographer_character2.skeleton} />
          </group>
          <group name="skeletal3">
            <primitive object={nodes.root4} />
          </group>
        </group>
      </group>
    </group>
  )
}

//useGLTF.preload('assets/glb-file/49.glb')
